import React, { useEffect, useState } from 'react';
import { EventDashboardSummary, EventShortInfo } from '../../ReportsClasses';
import { CDN_URL, PLACEHOLDER_IMG } from '../../ReportsConfig';
import { Groupper, Header, Image, Message, Placeholder, Stat } from 'react-frontier';
import { addCommas } from '@arema/components/Util';
import { Countdown } from '@arema/components';
import { useTranslation } from 'react-i18next';
import API from '../../ReportsAPI';
import moment from 'moment';

import '../../style/event_dashboard.scss';

interface EventStatsDashboardProps{
	event_id: number,
	event: EventShortInfo
}

var EventStatsDashboard = (props: EventStatsDashboardProps)=>{
	var { t } = useTranslation();
	var [data, setData] = useState<EventDashboardSummary>(null);
	var [loadError, setLoadError] = useState<string>(null);

	useEffect(()=>{
		if(data) return;
		API.getEventSummary(props.event_id).then(res=>{
			if(res.error) return setLoadError(res.message);
			setData(res.data);
			setLoadError(null);
		}).catch(err=>{
			return setLoadError(t('common.error_code', { type: 'cargando la información del evento', code: 'LCL-1' }));
		});
	}, []);
	
	var now = moment().unix();

	return <div className="ar event-stats-dashboard-screen">
		<div className="event">
			<Image src={`${CDN_URL}/events/${props.event.event_id}/400.webp`} alt={props.event.event_name} className="image" fallback={PLACEHOLDER_IMG} />
			<div className="name">{props.event.event_name}</div>
			<div className="promoter">
				{data ? data.event.promoter_name : (
					<Placeholder />
				)}
			</div>
		</div>
		{loadError ? (
			<Header text={'Error'} subtext={loadError} iconName='face-frown-open' style={{ marginTop: 20 }} />
		) : <>
			{data?.event && !data.event.published && (
				<Message type='info' header={t('dashboard.published.title')} centered style={{ maxWidth: 400, margin: 'auto', marginTop: 10 }}>
					{t('dashboard.published.text')}
				</Message>
			)}
			<Groupper className='summary' defaultStyle={false} fitted title={t('dashboard.summary.title')}>
				<div className="contents">
					{!!data && !!data.event.date_start && now<data.event.date_start && (
						<div className="row full">
							<Countdown unix={data.event.date_start} className='timer' days />
							<div className="label">{t('dashboard.summary.date_start')}</div>
						</div>
					)}
					<div className="row">
						<Stat value={(
							data ? `$${addCommas(data.stats.money, false, true)}` : <Placeholder height={36} />
						)} label={t('dashboard.summary.income')} />
						<Stat value={(
							data ? addCommas(data.stats.tickets, false, true) : <Placeholder height={36} />
						)} label={t('dashboard.summary.tickets')} />
					</div>
					<div className="row small">
						<Stat value={(
							data ? `$${addCommas(data.stats.average_sale)}` : <Placeholder height={36} />
						)} label={t('dashboard.summary.average')} />
						<Stat value={(
							data ? addCommas(data.stats.dates, false, true) : <Placeholder height={36} />
						)} label={t('dashboard.summary.dates')} />
					</div>
				</div>
			</Groupper>
		</>}
		{!!data && (
			<div className="timestamp">{t('dashboard.timestamp')}: {moment.unix(data.date).format('DD/MM/YYYY HH:mm:ss')}</div>
		)}
	</div>
}

export default EventStatsDashboard;